import { render } from "./MailView.vue?vue&type=template&id=548a76f8&ts=true"
import script from "./MailView.vue?vue&type=script&lang=ts"
export * from "./MailView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__